import React from 'react';
import { SectionWrapper } from './ui';
import { FileTextIcon, ClipboardListIcon, MapIcon, HeartPulseIcon, BrainIcon, TrendingUpIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
export const ProductOverview = () => {
  const tomos = [{
    id: 'T01',
    title: 'Legal',
    icon: <FileTextIcon size={20} data-id="element-212" />
  }, {
    id: 'T02',
    title: 'Admisión',
    icon: <ClipboardListIcon size={20} data-id="element-213" />
  }, {
    id: 'T03',
    title: 'Rutinas',
    icon: <MapIcon size={20} data-id="element-214" />
  }, {
    id: 'T04',
    title: 'Primeros Auxilios',
    icon: <HeartPulseIcon size={20} data-id="element-215" />
  }, {
    id: 'T05',
    title: 'Psicología',
    icon: <BrainIcon size={20} data-id="element-216" />
  }, {
    id: 'T06',
    title: 'Negocio',
    icon: <TrendingUpIcon size={20} data-id="element-217" />
  }];
  return <SectionWrapper className="bg-dark-bg text-center" data-id="element-218">
      <div className="inline-block bg-primary/10 border border-primary/30 rounded-full px-6 py-2 mb-6" data-id="element-219">
        <span className="text-primary font-bold" data-id="element-220">
          🐾 KIT PROFESIONAL DEL CUIDADOR 360™
        </span>
      </div>
      <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-221">
        6 Tomos + 6 Bonos · 500+ páginas · Todo resuelto.
      </h2>

      <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto mt-12" data-id="element-222">
        {tomos.map(t => <div key={t.id} className="flex items-center gap-2 bg-dark-card border border-dark-border px-4 py-3 rounded-xl shadow-lg" data-id="element-223">
            <span className="text-primary font-mono font-bold" data-id="element-224">{t.id}</span>
            <span className="text-gray-400" data-id="element-225">{t.icon}</span>
            <span className="text-white font-medium" data-id="element-226">{t.title}</span>
          </div>)}
      </div>
    </SectionWrapper>;
};
export const Tomos = () => {
  const tomosData = [{
    num: 1,
    title: 'BLINDAJE LEGAL Y CONTRATOS',
    desc: 'Contratos, cláusulas de deslinde y autorización veterinaria. Listo para usar hoy.'
  }, {
    num: 2,
    title: 'SISTEMA DE ADMISIÓN Y FICHAS',
    desc: 'Ficha canina, felina, medicación y conducta. Completable desde el celular.'
  }, {
    num: 3,
    title: 'RUTINAS Y PROTOCOLOS DE PASEO',
    desc: 'Check de puerta, protocolo de paseo seguro y planilla semanal lista.'
  }, {
    num: 4,
    title: 'PRIMEROS AUXILIOS Y GESTIÓN DE CRISIS',
    desc: 'Semáforo de urgencias, golpe de calor, atragantamiento y mochila de emergencias.'
  }, {
    num: 5,
    title: 'PSICOLOGÍA Y LENGUAJE CORPORAL',
    desc: 'Leé al animal antes de que muerda. Canino y felino.'
  }, {
    num: 6,
    title: 'MARKETING Y ADMINISTRACIÓN',
    desc: 'De hobby a negocio real. Precios, clientes y plan de 90 días.'
  }];
  const features = ['Protocolos listos para usar desde el minuto uno', 'Checklists visuales y plantillas completables', 'Lenguaje simple, directo y sin teoría innecesaria', 'Adaptado 100% a la realidad argentina'];
  return <SectionWrapper className="bg-dark-card/20" data-id="element-227">
      <div className="text-center mb-16" data-id="element-228">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-229">
          📚 6 TOMOS COMPLETOS
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16" data-id="element-230">
        {tomosData.map(t => <div key={t.num} className="bg-dark-card border border-dark-border rounded-2xl p-6 hover:border-primary/50 transition-colors group" data-id="element-231">
            <div className="flex items-center gap-4 mb-4" data-id="element-232">
              <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center font-black text-xl group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-233">
                T{t.num}
              </div>
              <div data-id="element-234">
                <h3 className="text-sm text-gray-400 font-bold tracking-wider" data-id="element-235">
                  TOMO {t.num}
                </h3>
                <p className="text-lg font-bold text-white leading-tight" data-id="element-236">
                  {t.title}
                </p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-237">{t.desc}</p>
          </div>)}
      </div>

      <div className="max-w-3xl mx-auto bg-dark-card border border-dark-border rounded-2xl p-8 shadow-xl" data-id="element-238">
        <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-239">
          Cada tomo incluye:
        </h3>
        <div className="grid md:grid-cols-2 gap-4" data-id="element-240">
          {features.map((feat, i) => <div key={i} className="flex items-start gap-3" data-id="element-241">
              <CheckCircle2Icon className="text-primary shrink-0 mt-0.5" size={20} data-id="element-242" />
              <span className="text-gray-300 text-sm md:text-base" data-id="element-243">{feat}</span>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    title: 'Kit Express de Respuestas por WhatsApp',
    val: '$8.000'
  }, {
    num: '02',
    title: 'Checklist de Primera Visita Sin Errores',
    val: '$7.000'
  }, {
    num: '03',
    title: 'Mini Guía de Presentación Profesional',
    val: '$8.000'
  }, {
    num: '04',
    title: 'Plantillas de Reporte Diario que Enamoran Clientes',
    val: '$9.000'
  }, {
    num: '05',
    title: 'Checklist de Mochila del Cuidador Profesional',
    val: '$7.000'
  }, {
    num: '06',
    title: 'Guía de Errores que Hacen Ver Amateur a un Cuidador',
    val: '$9.000'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-244">
      <div className="text-center mb-16" data-id="element-245">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/20 text-accent rounded-full mb-6" data-id="element-246">
          <GiftIcon size={32} data-id="element-247" />
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-248">
          🎁 6 BONOS ESTRATÉGICOS
        </h2>
        <p className="text-2xl text-accent font-bold tracking-widest uppercase" data-id="element-249">
          Siempre incluidos
        </p>
      </div>

      <div className="max-w-4xl mx-auto mb-12" data-id="element-250">
        <div className="overflow-x-auto rounded-xl border border-accent/20 shadow-xl" data-id="element-251">
          <table className="w-full text-left border-collapse" data-id="element-252">
            <thead data-id="element-253">
              <tr className="bg-dark-card border-b border-accent/20" data-id="element-254">
                <th className="p-4 text-sm font-bold text-accent uppercase w-16 text-center" data-id="element-255">
                  #
                </th>
                <th className="p-4 text-sm font-bold text-white uppercase" data-id="element-256">
                  Bono
                </th>
                <th className="p-4 text-sm font-bold text-gray-400 uppercase text-right" data-id="element-257">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody data-id="element-258">
              {bonuses.map(b => <tr key={b.num} className="border-b border-dark-border/50 hover:bg-dark-card/50 transition-colors" data-id="element-259">
                  <td className="p-4 text-accent font-black text-xl text-center" data-id="element-260">
                    {b.num}
                  </td>
                  <td className="p-4 text-white font-medium" data-id="element-261">{b.title}</td>
                  <td className="p-4 text-right" data-id="element-262">
                    <span className="text-gray-500 line-through mr-2" data-id="element-263">
                      {b.val}
                    </span>
                    <span className="text-primary font-bold" data-id="element-264">→ GRATIS</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-2xl mx-auto text-center bg-accent/10 border border-accent/30 rounded-2xl p-8" data-id="element-265">
        <p className="text-gray-300 text-lg mb-2" data-id="element-266">Valor total bonos</p>
        <p className="text-3xl md:text-4xl font-black text-white" data-id="element-267">
          <span className="text-gray-500 line-through mr-4" data-id="element-268">$48.000</span>
          <span className="text-accent" data-id="element-269">→ GRATIS con tu Kit</span>
        </p>
      </div>
    </SectionWrapper>;
};